<template>
    <div class="mobile-menu-wrapper" :class="{open: menuOpen}">
        <div class="mobile-menu">
            <ul class="menu">
                <template v-for="item in menu">
                    <li :key="`menu-item-${item.id}`"
                        class="menu-item"
                        @click="checkLink(item)"
                        :class="{ 'active': item.isActive }">
                        <a v-if="item.external || isIE10"
                           :href="item.url"
                           class="menu-link"
                           target="_blank">
                            {{ item.title }}
                        </a>
                        <router-link v-else
                                     class="menu-link"
                                     :to="item.url">
                            {{ item.title }}
                        </router-link>
                    </li>
                </template>
            </ul>
        </div>
        <div class="mobile-menu-footer">
            <ul class="menu footer-menu">
                <li v-if="residentLink.display" class="menu-item">
                    <a :href="residentLink.url" class="menu-link">
                        {{ residentLink.text }}
                    </a>
                </li>
                <li v-if="phoneLink.display" class="menu-item">
                    <a :href="`tel:${phoneNumber}`" class="menu-link phone">
                        {{ phoneNumber }}
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import MenuMixin from './mixin.menu'

    export default {
        name: "HeaderMenuMobile",
        mixins: [ MenuMixin ],
        props: {
            menuOpen: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                residentLink: wp.settings.headerOptions.resident_link,
                phoneLink: wp.settings.headerOptions.phone_number_link,
                phoneNumber: wp.settings.phoneNumber
            }
        },
        methods: {
            checkLink(link) {
                // toggle Menu if link is same as current page
                if (this.$route.fullPath === link.url) {
                    this.$emit('toggleMenu')
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

    .mobile-menu-wrapper {
        z-index: 900;
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: $theme-blue;
        display: flex;
        flex-direction: column;
        transform: translateX(100%);
        transition: all .8s cubic-bezier(.4,0,.2,1) 0s;

        &.open {
            pointer-events: all;
            transform: translateX(0);
        }

        @media (max-height: 450px) {
            display: block;
            overflow: scroll;
            margin-top: 60px;
            height: auto;
        }
    }

    .mobile-menu {
        height: 100%;
        display: flex;
        align-items: center;

        @media (max-height: 450px) {
            display: block;
            height: auto;
        }
    }

    .menu {
        @media (max-height: 450px) {
            margin-bottom: 0;
        }
    }

    .mobile-menu-footer {
        @media (min-height: 530px) {
            position: fixed;
            bottom: 0;
        }
    }

    .menu-item {
        margin: 20px 0;
    }

    .menu-link {
        color: $white;
        font-family: inherit;
        text-decoration: none;
        font-size: 30px;

        &:hover {
            cursor: pointer;
            color: $theme-orange;
        }
    }

</style>